module.exports = __webpack_public_path__ + "static/media/miss.99cfe5ff.svg";